import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../../store';
import megatron from '@stencil/megatron';
import querystring from 'query-string';
import { prepareReviewApiRequest, preparePromoDiscountApiRequest, prepareTentativeAPIReqURL, prepareGoSafeUrl, prepareSocialDistanceUrl } from './../Api';
import { IREVIEW_REQUEST, IPROMO_REQUEST, ITENTATIVE_PROPS } from './../Validation';
import { getter, setter , setterSessionStorage} from '@stencil/client-side-storage';
import { getCookie, prepareBookingData } from './../Utils';
import { toggleReviewDataLoading, setGoSafeData, setGoSafeSocialData, setSelectedPromoCode, toggleGoCashSelection, setGoTribe, updateGoTribeData } from './actions';
import { pushDataToNewrelic } from './../../Common/Utils'
import { goTribeUrlPath } from '../../../config/apiPoints';

//TODO:- handle the failure cases . ... add a dispatcha ction in case of error or failure so that it should be handled by state management .
export const fetchReviewData = (props: IREVIEW_REQUEST): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    dispatch(toggleReviewDataLoading({ isLoading: true, reviewData: {} }));
    try {
      /*   * 1. call the GA event
           * 2. mechanism for cb or any other way to show toast based on the message .
             *  */

      const state = getState();
      const userState = state['user'];
      const isLoggedIn = userState.isLoggedIn || false;
      const { seats, src, dest, src_vid, dest_vid, doj, routeId, bpDetail, token, dpDetail, selectedSeatsData, journeyType, fd, bookingKey, redDealsDiscount, cat_card_selected, page_source } = props;
      let { querydata } = props;
      pushDataToNewrelic(`reviewVal=${querydata.replace("#", "")}`);


      if (querydata.indexOf('#') === -1) {
        querydata = '#' + querydata;
      }


      const url = prepareReviewApiRequest({ bookingKey, querydata, token, page_source });

      let data;
      if (token) {
        data = await megatron({
          name: 'Bus Review',
          type: 'GET',
          url,
          credentials: 'include',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        });
      }
      else {
        const bookingdata = prepareBookingData({ selectedSeatsData, routeId, journeyType, bpDetail, dpDetail, fd, redDealsDiscount, cat_card_selected, page_source })

        data = await megatron({
          name: 'Bus Review',
          type: 'POST',
          url,
          credentials: 'include',
          requestData: querystring.stringify({ querydata, bookingdata: JSON.stringify(bookingdata) }),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        });
      }
      if (data && data.b_token) {
        pushDataToNewrelic(`reviewData=success&bookingKey=${bookingKey}`);

      } else {
        pushDataToNewrelic(`reviewData=failure&bookingKey=${bookingKey}`);

      }
      if (data.error) {
        pushDataToNewrelic(`reviewDataErr=${bookingKey}`);


        dispatch(toggleReviewDataLoading({ isLoading: false, isError: true, reviewData: {} }));
        return;
      }
      setData({ bookingKey, routeId, data });

      dispatch(toggleReviewDataLoading({ isLoading: false, reviewData: data }));

      const promo_applied = data.promo_applied;
      let preapplied_promokey = '';
      if (promo_applied && Object.keys(promo_applied).length && promo_applied.success && promo_applied.promoname) {
        preapplied_promokey = promo_applied.promoname;
        dispatch(setSelectedPromoCode(preapplied_promokey));
      }

      dispatch(
        fetchPromoData({ code: preapplied_promokey, leadcodes: [], isGocashSelected: isLoggedIn, queryData: querydata, token: data.b_token, action: isLoggedIn ? 'gocash_applied' : '', page_source: page_source, firstCall: true }),
      );
    } catch (err) {
      dispatch(toggleReviewDataLoading({ isLoading: false, isError: true, reviewData: {} }));
      pushDataToNewrelic(`reviewDataFailure=${props.bookingKey}`);
      console.trace(err);
    }
    finally {

    }
  };
}
export const fetchPromoData = (props: IPROMO_REQUEST): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    /* 1. store data in redux of there
       * 2. call the GA event
       * 3. mechanism for cb or any other way to show toast based on the message .
         *  */

    const { code = '', leadcodes = [], isGocashSelected = false, queryData, token, action, page_source, firstCall } = props;
    try {

      const url = preparePromoDiscountApiRequest();

      const data = await megatron({
        name: 'Bus Review',
        type: 'POST',
        url,
        requestData: querystring.stringify({
          code,
          leadcodes: JSON.stringify(leadcodes),
          querydata: queryData,
          gocash: isGocashSelected,
          token,
          action,
          page_src: page_source || ''
        }),
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      if (firstCall && data && !data.error) {
        dispatch(toggleReviewDataLoading({ isLoading: false, reviewData: data }));
        const isGocashApplied = data.gocash && data.gocash.is_gocash_applied ? true : false;
        dispatch(toggleGoCashSelection(isGocashApplied));
      }
      return data;
    } catch (err) {
      return { error: "Something Went Wrong" }
    }
  };
}

export const callTentativeAPI = (props: ITENTATIVE_PROPS): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    /* 1. store data in redux of there
       * 2. call the GA event
       * 3. mechanism for cb or any other way to show toast based on the message .
         *  */
    /**
     * {error: "request data expired."
    action: "seatlayout"}
    
     */
    //  dispatch(updateTentativeAction({isLoading:true,isError:false,data:{}}))
    try {
      const { querydata, fareTotal, udf1, mobile, email, credits, token, isSeniorCitizen, isCatCard, travellerData, businessInfo, tripType,
        srCitizenCardNumber, catCardNumber, gst_details, pageLoadEventTagsJsonStr, is_sponsored, is_bo_ads

      } = props;
      const url = prepareTentativeAPIReqURL();
      const device_id = sessionStorage.getItem('device_id')
      const newPostData = {
        querydata,
        hiddenPrice: fareTotal,
        amountCr: udf1,
        totfare: fareTotal,
        idprooftype: 'Driving License',//?
        idproofnum: 123455,//?
        mobile,
        email,
        firstname: travellerData[0].name,
        lastname: '',//?
        address: 'ibibo Web Private Limited, 5th Floor, Good Earth City Centre, Sector 50, Gurgaon, Haryana-122018',//?
        city: 'Bangalore',//?
        pincode: '122002',//?
        state: 'Delhi',//?
        country: 'Country',//?
        landline: 'Landline',//?
        credits_amount: credits,
        native_pay_amnt: fareTotal,
        token,
        promocode: '',//?
        gst_details,
        pageLoadEventTagsJsonStr,
        is_sponsored,
        is_bo_ads
      };
      if (tripType == "business") {
        newPostData['type'] = tripType;
        newPostData['pay_gst_number'] = businessInfo.gstNumber;
        newPostData['pay_gst_company_name'] = businessInfo.companyName;
        newPostData['pay_gst_business_email'] = businessInfo.businessMail;
        newPostData['pay_gst_company_address'] = businessInfo.companyAddress;
        newPostData['pay_gst_phone_number'] = businessInfo.phoneNumber;
        newPostData['state'] = businessInfo.state;
        newPostData['country'] = businessInfo.country;
      }
     
      if (isSeniorCitizen) {
        newPostData.srctzn_card_detail = srCitizenCardNumber;
      }

      if (isCatCard) {
        newPostData.cat_card_detail = catCardNumber;
      }

      travellerData.forEach((item, index) => {
        newPostData['adultchoose' + (index + 1)] = item.gender === 'Male' ? 1 : 2;
        newPostData['adultfirstname' + (index + 1)] = item.name;
        newPostData['adultlastname' + (index + 1)] = '';
        newPostData['adultage' + (index + 1)] = item.age;
        newPostData['adultonwseat' + (index + 1)] = item.seat;
      });
       
      const headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
      if(device_id){
        headers['device-id'] = device_id
      }
      const data = await megatron({
        name: 'Bus Tentative',
        type: 'POST',
        url,
        requestData: querystring.stringify({
          ...newPostData
        }),
       credentials: 'include',
        headers: headers,
      });

      return data;

      //dispatch(updateTentativeAction({isLoading:false,isError:false,data:data}))

    } catch (err) {
      return { err: "failed" }
      // dispatch(updateTentativeAction({isLoading:false,isError:false,data:{}}))

    }
  };
}

export function setData({ bookingKey, routeId, data }) {
  setterSessionStorage('bus',
    {
      'reviewCollection': {
        [bookingKey + routeId]: data
      }
    })
}

export const callGoSafeMeasure = (props: {
  go_safe: boolean;
  soc_dis: boolean;
}): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const { go_safe, soc_dis } = props;
    const state = getState();
    const goSafeData = state['review']['goSafe'];
    if (!Object.keys(goSafeData.data).length && !goSafeData.isLoading) {
      dispatch(setGoSafeData({ data: {}, headerMsg: '', isLoading: true }))

      const url = prepareGoSafeUrl();

      try {
        let { data } = await megatron({
          name: 'Bus Go Safe Review',
          type: 'GET',
          url
        })

        let message = "Great! Your bus is goSafe protected for safe travel.";
        if (go_safe && soc_dis) {
          message = "Great! Your bus is goSafe protected and follows social distancing for safe travel.";
        } else if (soc_dis) {
          message = "Great! Your bus follows social distancing for safe travel."
        }
        dispatch(setGoSafeData({ data: data.slots.bus_review_gosafe, headerMsg: message, isLoading: false }))



      } catch (err) {
        console.error("error while loading gosafe data");
        dispatch(setGoSafeData({ data: {}, headerMsg: '', isLoading: false }))

      }
    }
  };
}


export const callSocialDistance = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    const state = getState();
    const goSafeSocialData = state['review']['goSafeSocial'];
    if (!Object.keys(goSafeSocialData.data).length && !goSafeSocialData.isLoading) {

      dispatch(setGoSafeSocialData({ data: {}, headerMsg: '', isLoading: true }))

      const url = prepareSocialDistanceUrl();

      try {
        let { data } = await megatron({
          name: 'Bus Social Distance Review',
          type: 'GET',
          url
        })
        if (data.slots && data.slots.bus_gosafe_social_distance) {
          let message = "Great! Your bus follows social distancing for safe travel."
          dispatch(setGoSafeSocialData({ data: data.slots.bus_gosafe_social_distance, headerMsg: message, isLoading: false }))
        }


      } catch (err) {
        console.error("error while loading gosafe data");
        dispatch(setGoSafeSocialData({ data: {}, headerMsg: '', isLoading: false }))
      }
    };
  }
}

export const fetchTribeDetails = ({ pageName }): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    try {
      let request_data = {};
      const state = getState();

      if (pageName == "REVIEW") {
        const { common = {}, review = {} } = state;
        const { dojObj = {} } = common;
        const { reviewData = {} } = review;
        const { total_fare } = reviewData;

        request_data = {
          "bookingDate": new Date().getTime(),
          "bookingAmount": total_fare,
          "group": "BUS",
          "bookingCategory": "DOMESTIC",
          "travelDate": dojObj.getTime(),
          "pageType": pageName,
          "pah": false,
          "lobParams": null,
          "bookingId": null,
          "source": "caller",
          "platform": "DWEB"
        }
      } else {
        const { common = {}, thankyou } = state;
        const { bookingList, amt = 0, flavour } = thankyou.data;
        const total_fare = amt;
        const { depDate, po, bookingDate } = bookingList && bookingList[0];
        const platform = flavour == "mobile" ? "PWA" : "DWEB";

        request_data = {
          "bookingDate": new Date(bookingDate).getTime(),
          "bookingAmount": total_fare,
          "group": "BUS",
          "bookingCategory": "DOMESTIC",
          "travelDate": new Date(depDate).getTime(),
          "pageType": "THANKYOU",
          "pah": false,
          "lobParams": null,
          "bookingId": po,
          "source": "caller",
          "platform": platform
        }
      }

      const auth = getCookie('OAUTH-GOIBIBO');
      const url = `${__ENV_CONFIG__.__GOTRIBEURL__}${goTribeUrlPath}`;

      const headers = {
        Authorization: "7NP82fpV0TsA9JrK", 'Content-Type': 'application/json; charset=UTF-8',
        org: "GI",
        region: "IND",
        auth: auth || ""
      };

      // TODO platform change to PWA and DWEB

      const options = {
        headers,
        method: 'POST',
        body: JSON.stringify(request_data)
      };
      const request = new Request(url);
      const rawResponse = await fetch(request, options);
      const response = await rawResponse.json();

      // let response = {
      //   "errors": [],
      //   "walletEarn": 13.0,
      //   "loyaltyEligible": false,
      //   "tierName": "goTribe Star",
      //   "messageTitle": "Earn goCash",
      //   "messageText": "Book & Earn <b>₹13 goCash</b> Instantly",
      //   "iconUrl": "https://gos3.ibcdn.com/gotribeIcon-1662100938.png",
      //   "cta": null,
      //   "ctaLink": null,
      //   "ctaActionType": null,
      //   "textList": null,
      //   "tnc": null,
      //   "walletStatus": false,
      //   "pendingStateMessage": null,
      //   "walletMessage": null,
      //   "ctaAction": null,
      //   "iconColor": "#fdddd3"
      // }

      // let response = {
      //   "errors": [],
      //   "walletEarn": 50.0,
      //   "loyaltyEligible": false,
      //   "tierName": "GOTRIBE SUPERSTAR",
      //   "messageTitle": "Earn Gocash",
      //   "messageText": "Adding ₹50 goCash to your wallet",
      //   "iconUrl": "https://gos3.ibcdn.com/gotibelogo_superstar-1598286680.png",
      //   "cta": null,
      //   "ctaLink": null,
      //   "ctaActionType": null,
      //   "textList": null,
      //   "walletMessage ": "Use it to book your next flight, hotel or cab. Club it with our discounts to save max!",
      //   "pendingStateMessage": "It usually takes about 5 minutes to be added",
      //   "walletStatus": false,
      //   "ctaAction": null,
      //   "tnc": null,
      //   "iconColor": "#fef8e5"
      // }

      if (response && typeof response == 'object') {
        if (response?.errors && response?.errors?.length == 0) {
          dispatch(setGoTribe(response, true));
        } else {
          dispatch(updateGoTribeData(false));
        }
      } else {
        dispatch(updateGoTribeData(false));
      }
    } catch (err) {
      console.error("err", err);
    }
  };
};
